import React from "react";
import { FaEnvelope, FaGithub } from "react-icons/fa";

const Footer = () => (
  <footer className="relative border-t border-white/10">
    <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
      <p>Kavi Sekhon — Independent Developer &amp; Researcher · Data / AI / ML / Infrastructure</p>
      <div className="flex items-center gap-5">
        <a
          href="mailto:kavi.sekhon@kavisekhon.com"
          aria-label="Email"
          className="hover:text-white transition-colors"
        >
          <FaEnvelope className="text-sm" />
        </a>
        <a
          href="https://github.com/kavisek"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
          className="hover:text-white transition-colors"
        >
          <FaGithub className="text-sm" />
        </a>
        <span className="tabular-nums">v{process.env.REACT_APP_VERSION}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
